import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, CATEGORIES } from "../lib/api";
import { TimelapseCard } from "../components/TimelapseCard";
import { Search } from "lucide-react";

export default function Gallery() {
  const [params, setParams] = useSearchParams();
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const category = params.get("category") || "All";

  useEffect(() => { document.title = "Gallery — Lumenlapse"; }, []);
  useEffect(() => {
    const q = {};
    if (category !== "All") q.category = category;
    if (search) q.search = search;
    api.get("/timelapses", { params: q }).then(({ data }) => setItems(data));
  }, [category, search]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-24">
      <div className="overline-label mb-3">The full catalog</div>
      <h1 className="font-serif text-5xl lg:text-6xl font-light">Gallery</h1>

      <div className="mt-8 flex flex-col lg:flex-row lg:items-center gap-4 justify-between">
        <div className="flex flex-wrap gap-2">
          {CATEGORIES.map((c) => (
            <button key={c} data-testid={`gallery-filter-${c}`}
              onClick={() => setParams(c === "All" ? {} : { category: c })}
              className={`px-4 py-2 rounded-full text-sm border transition-colors ${
                category === c ? "border-amber-glow text-amber-glow bg-amber-glow/10" : "border-white/12 text-neutral-300 hover:border-white/30"
              }`}>
              {c}
            </button>
          ))}
        </div>
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500" />
          <input data-testid="gallery-search" value={search} onChange={(e) => setSearch(e.target.value)}
            placeholder="Search location, tag…"
            className="pl-9 pr-4 py-2 bg-obsidian-800 border border-white/12 rounded-full text-sm w-64 outline-none focus:border-amber-glow/60" />
        </div>
      </div>

      {items.length === 0 ? (
        <div className="py-32 text-center text-neutral-500">No sequences found.</div>
      ) : (
        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map((tl, i) => <TimelapseCard key={tl.id} tl={tl} index={i} />)}
        </div>
      )}
    </div>
  );
}
